<template>
<div class="chapter">
<div class="inner_page">
<h1 class="head">I</h1>
<h1 class="head1"><em>A Chance</em></h1>
<h1 class="head01"><em>to Live</em></h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?43ffcc98